import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  Input,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {
  getUserProfile,
  resetProfileState,
  updateUserProfile,
} from '../../../store/Authentication/authentication.actions';
import { Store, select } from '@ngrx/store';
import {
  getUpdatedUserProfileResponse,
  getUserProfileFailure,
  userDetails,
} from '../../../store/Authentication/authentication-selector';
import { LoaderService } from '../../../core/services/loader.service';
import { UserProfile } from '../../../shared/modals/common';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Validations } from '../../../shared/constants/validations';
import { SharedService } from '../../../shared/shared.service';
import { SweetAlertIcon } from '../../../shared/constants/enum';
import { AuthenticationService } from '../../../core/services/auth.service';
@Component({
  selector: 'app-rp-user-profile',
  templateUrl: './rp-user-profile.component.html',
  styleUrl: './rp-user-profile.component.scss',
})
export class RpUserProfileComponent {
  mode: any;
  element: any;
  nameRegex = '^[a-zA-Z]+(?: [a-zA-Z]+)?(?: [a-zA-Z]+)?$';
  cookieValue: any;
  flagvalue: any;
  countryName: any;
  valueset: any;
  theme: any;
  submitted: boolean = false;
  error$: any;
  url: any = '';
  profileData: UserProfile = {
    firstName: '',
    lastName: '',
    email: '',
    secondaryEmail: '',
    phoneNumber: 0,
    fileUrl: '',
    secondaryPhoneNumber: '',
    id: '',
  };

  prifileValidations = Validations.ProfilePage;
  profileForm!: UntypedFormGroup;
  constructor(
    private router: Router,
    private store: Store,
    public translate: TranslateService,
    private modalService: BsModalService,
    private loaderService: LoaderService,
    private formBuilder: UntypedFormBuilder,
    private sharedService: SharedService,
    private authenticationService: AuthenticationService,
  ) {
   // this.getStoreInfo();
  }

  resetUpdateProject() {
    this.store.dispatch(resetProfileState());
  }

  getStoreInfo() {
    this.resetUpdateProject();
   /*  this.error$ = this.store.pipe(select(getUserProfileFailure));
    this.error$.subscribe((res: any) => {
      this.loaderService.setLoading(false);
      console.log('err', res);
    }); */
  }

  get f() {
    return this.profileForm.controls;
  }

  closePopUp() {
    const profileData = {
      firstName: 'John',
      lastName: 'Doe',
      email: 'john@example.com',
      mobileNumber: '1234567890',
      secondMobileNumber: '0987654321',
    };

    // this.profileSaved.emit(profileData);
    this.modalService.hide();
  }

  ngOnInit() {
    console.log(this.profileData);
    this.profileForm = this.formBuilder.group({
      firstName: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(30),
          Validators.pattern(this.nameRegex),
        ],
      ],
      lastName: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(30),
          Validators.pattern(this.nameRegex),
        ],
      ],
      profileImg: [''],
      emailAddress: [
        { value: '', disabled: true },
        ,
        [Validators.required, Validators.email],
      ],
      mobileNumber: [
        { value: '', disabled: true },
        ,
        [Validators.required, Validators.pattern('[0-9]*')],
      ],
      secondaryEmail: [
        '',
        [
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          ),
        ],
      ],
      secondaryPhoneNumber: [
        '',
        [
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern(/^[6-9]\d{9}$/),
        ],
      ],
      // Add more form controls as needed
    });
    this.loaderService.setLoading(true);
    this.getUserProfile();
    // this.store.dispatch(getUserProfile());
  }

  getUserProfile() {
    this.loaderService.setLoading(true);
    this.authenticationService.getUserProfile().subscribe({
      next: (response) => {
        this.loaderService.setLoading(false);
         console.log('profileData', this.profileData);
        if (response.statusCode === 200) {
          this.profileData = response.data;
          this.profileForm.patchValue({
            firstName: this.profileData.firstName,
            lastName: this.profileData.lastName,
            emailAddress: this.profileData.email,
            mobileNumber: this.profileData.phoneNumber,
            secondaryEmail: this.profileData.secondaryEmail,
            profileImg: this.profileData.fileUrl,
            secondaryPhoneNumber: this.profileData.secondaryPhoneNumber,
            // Patch other form controls as needed
          });
          this.url = this.profileData.fileUrl;
          Object.keys(this.profileForm.controls).forEach(key => {
            const control = this.profileForm.get(key);
            control?.markAsTouched();
            control?.updateValueAndValidity();
          });

        }
        console.log('responseprofie', this.profileForm.getRawValue(), response);
       // console.log('responseprofie', response, this.url);
      }
    })
  }

  onSubmit(): void {
    this.submitted=true
    this.profileForm.markAllAsTouched();
   
   
    if (
      this.f['secondaryPhoneNumber'].value &&
      this.f['mobileNumber'].value &&
      this.f['secondaryPhoneNumber'].value === this.f['mobileNumber'].value
    ) {
       console.log('same number');
      return;
      // your logic here
    }
    if (
      this.f['secondaryEmail'].value &&
      this.f['emailAddress'].value &&
      this.f['secondaryEmail'].value === this.f['emailAddress'].value
    ) {
      console.log('same email');
      return;
      // your logic here
    }


    console.log(this.profileForm.value);


    this.submitted = true;
    if (this.profileForm.valid) {
      this.loaderService.setLoading(true);
     
      console.log(this.profileData);
      // this.store.dispatch(updateUserProfile(this.profileForm.value));

      //updateUserProfile
      const finalPayload = {
        ...this.profileForm.value,
        id: this.profileData?.id, // or however you are storing userId
      };
      console.log(finalPayload);
      this.authenticationService.updateUserProfile(finalPayload).subscribe({
        next: (response) => {
          this.loaderService.setLoading(false);
          this.closePopUp()
          this.sharedService.showMessageDialog(
            'Success',
            response.message,
            SweetAlertIcon.SUCCESS
          );
          this.getUserProfile();
        },
        error: (err) => {
          this.loaderService.setLoading(false);
          this.sharedService.showMessageDialog(
            'Error',
            'Failed to update profile',
            SweetAlertIcon.ERROR
          );
        },
      });
    }
  }

  onSelectFile(event: any): void {
    const file = event.target.files[0];
    console.log(file);

    if (file && file.type.startsWith('image/')) {
      this.profileForm.patchValue({
        profileImg: file,
      });
      this.profileForm.get('profileImg')?.updateValueAndValidity();

      // Display the selected image preview
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.url = reader.result;
      };
    } else {
      this.sharedService.showMessageDialog(
        'Error',
        'Please select a valid image file',
        SweetAlertIcon.ERROR
      );
    }
  }
}
